export const buildInfo = {"timestamp":"2026-11-03T12:57:06.315Z"};